export enum UserGridType {
  LocoTypes = 'locoTypes',
  ActivityTypes = 'activityTypes',
  OperationPoints = 'operationPoints',
  ImParameters = 'imParameters',
  Labels = 'labels',
  RecentActivity = 'recent',
  QuickSearch = 'quickSearch',
  AdvancedSearch = 'search',
  BulkDossierPromotion = 'bulkDossierPromotionSearch',
  BulkAcceptanceIndicatorEdit = 'bulkAcceptanceIndicatorEditSearch',
  BulkPermanentAcceptance = 'bulkPermanentAcceptanceSearch',
  BulkRuAppointment = 'bulkRuAppointmentSearch',
  BulkRuAppointmentProcessing = 'bulkRuAppointmentProcessingSearch',
  CarryForward = 'carryForwardSearch',
  PaPSearch = 'papSearch'
}
